import { useAgent } from "../../utils/agent/AgentProvider.js";
import { useStwContext } from "../../utils/stwInfo/hook.js";
import { useState, useRef, useEffect } from "react";
import "../../components/Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../components/Chrome/BrowseContext/hook.js";
const getAddressLocation = async (agent, q, setStwErrorMessage) => {
  const results = await agent.getGeoServiceLocation(q);
  if (results[0]) {
    return {
      latitude: results[0].latitude,
      longitude: results[0].longitude
    };
  } else {
    setStwErrorMessage && setStwErrorMessage(true);
    return null;
  }
};
const validatePostalCode = (postalCode, validationSchema) => {
  try {
    validationSchema.parse({ zipCode: postalCode });
    return true;
  } catch {
    return false;
  }
};
const useLocation = (latitude, longitude, validationSchema, isSTW, setStwErrorMessage) => {
  const { bdDeliveryLocation, thirdPartyInfo, userLocation } = useBrowseContext();
  const { stwPostalCode } = useStwContext();
  const { agent } = useAgent();
  const [location, setLocation] = useState(
    void 0
  );
  const isGettingAddressLocation = useRef(false);
  let postalCode;
  if (isSTW) {
    const cookiePostalCode = (userLocation == null ? void 0 : userLocation.zip) || thirdPartyInfo.akamaiZipCode || "";
    postalCode = stwPostalCode || cookiePostalCode;
  } else {
    postalCode = (userLocation == null ? void 0 : userLocation.zip) || (bdDeliveryLocation == null ? void 0 : bdDeliveryLocation.zipCode) || ((thirdPartyInfo == null ? void 0 : thirdPartyInfo.akamaiZipCode) && validatePostalCode(thirdPartyInfo.akamaiZipCode, validationSchema) ? thirdPartyInfo.akamaiZipCode : "") || "";
  }
  useEffect(() => {
    const getLocation = async (postalCode2) => {
      if (!agent) {
        return;
      }
      isGettingAddressLocation.current = true;
      let updatedLocation = {
        latitude,
        longitude
      };
      if (postalCode2) {
        try {
          const addressLocation = await getAddressLocation(
            agent,
            postalCode2,
            setStwErrorMessage
          );
          if (addressLocation) {
            updatedLocation = addressLocation;
          }
        } catch (_) {
        }
      }
      setLocation((prevLocation) => {
        if (prevLocation && prevLocation.latitude === updatedLocation.latitude && prevLocation.longitude === updatedLocation.longitude) {
          return prevLocation;
        }
        return updatedLocation;
      });
      isGettingAddressLocation.current = false;
    };
    if (!isGettingAddressLocation.current) {
      getLocation(postalCode);
    }
  }, [agent, latitude, longitude, postalCode, setStwErrorMessage]);
  return location;
};
export {
  useLocation
};
